import { render, staticRenderFns } from "./HomePageTwo.vue?vue&type=template&id=147b0808&scoped=true&"
import script from "./HomePageTwo.vue?vue&type=script&lang=ts&"
export * from "./HomePageTwo.vue?vue&type=script&lang=ts&"
import style0 from "./HomePageTwo.vue?vue&type=style&index=0&id=147b0808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147b0808",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VLayout})
